"use client";

import type { ErrorResponse, OkResponse } from "../types/serviceResponse";
import type { SearchResponse } from "../types/content";
import type { FetchError } from "../types/fetchError";

export const searchArticlesAndTopicsFromUrl = async (
  url: string,
): Promise<
  OkResponse<SearchResponse & { nextPage: string }> | ErrorResponse
> => {
  try {
    const urlParsed = new URL(url);
    const limit = urlParsed.searchParams.get("limit");
    const offset = urlParsed.searchParams.get("offset");
    urlParsed.searchParams.set("offset", `${Number(offset) + Number(limit)}`);

    const res = await fetch(url);

    // Handle internal server errors such 404 and 500s
    if (!res.ok && ![401, 403].includes(res.status)) {
      return {
        error: {
          status: res.status,
          statusText: res.statusText,
          message: `Failed to search: ${res.status} ${res.statusText}`,
        } as FetchError,
        data: null,
      };
    }

    const result: SearchResponse = await res.json();
    const data = {
      ...result,
      nextPage: urlParsed.toString(),
    };
    return { data, error: null };
  } catch (e) {
    const error = e as Error;
    console.error(error);
    return {
      data: null,
      error: {
        message: error.message,
      } as FetchError,
    };
  }
};
